import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/10 mt-32">
      <div className="max-w-[1400px] mx-auto px-[7.6923%] py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_3dc7acc6-cad7-4ff2-a881-71992e987d42/artifacts/i4tnc7pr_IMG_1216.png"
              alt="Zonik Solutions Logo"
              className="h-12 w-auto object-contain mb-6"
            />
            <p className="text-white/85 text-base leading-relaxed mb-4">
              Moderne Webentwicklung und digitales Marketing für Unternehmen, die wachsen wollen.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-xl font-semibold mb-6">Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/leistungen" className="text-[#4D4D4D] hover:text-white transition-colors duration-300 text-base">
                  Leistungen
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-[#4D4D4D] hover:text-white transition-colors duration-300 text-base">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#4D4D4D] hover:text-white transition-colors duration-300 text-base">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/ueber-uns" className="text-[#4D4D4D] hover:text-white transition-colors duration-300 text-base">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-[#4D4D4D] hover:text-white transition-colors duration-300 text-base">
                  Kontakt
                </Link>
              </li>
            </ul>
            
            <h3 className="text-white text-xl font-semibold mb-6 mt-8">Standorte</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/webentwicklung-berlin" className="text-[#4D4D4D] hover:text-white transition-colors duration-300 text-base">
                  Berlin
                </Link>
              </li>
              <li>
                <Link to="/webentwicklung-muenchen" className="text-[#4D4D4D] hover:text-white transition-colors duration-300 text-base">
                  München
                </Link>
              </li>
              <li>
                <Link to="/webentwicklung-hamburg" className="text-[#4D4D4D] hover:text-white transition-colors duration-300 text-base">
                  Hamburg
                </Link>
              </li>
              <li>
                <Link to="/webentwicklung-koeln" className="text-[#4D4D4D] hover:text-white transition-colors duration-300 text-base">
                  Köln
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white text-xl font-semibold mb-6">Kontakt</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="text-[#FF4444] mt-1" size={20} />
                <div className="text-white/85 text-base">
                  {companyInfo.address}<br />
                  {companyInfo.postalCode} {companyInfo.city}
                </div>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="text-[#FF4444]" size={20} />
                <a href={`mailto:${companyInfo.email}`} className="text-white/85 hover:text-white transition-colors duration-300 text-base">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#4D4D4D] text-sm">
            © {new Date().getFullYear()} {companyInfo.name}. Alle Rechte vorbehalten.
          </p>
          <div className="flex gap-6">
            <Link to="/impressum" className="text-[#4D4D4D] hover:text-white transition-colors duration-300 text-sm">
              Impressum
            </Link>
            <Link to="/datenschutz" className="text-[#4D4D4D] hover:text-white transition-colors duration-300 text-sm">
              Datenschutz
            </Link>
            <Link to="/cookies" className="text-[#4D4D4D] hover:text-white transition-colors duration-300 text-sm">
              Cookie-Hinweis
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;